var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container tasks-page-section" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "custom-btn-secondary mr-1",
                attrs: {
                  disabled: _vm.selected.length === 0 || _vm.isBusyExport
                },
                on: {
                  click: function($event) {
                    return _vm.exportTimesheetFile()
                  }
                }
              },
              [
                _vm.isBusyExport
                  ? _c("b-spinner", { attrs: { small: "" } })
                  : _vm._e(),
                _vm._v(" "),
                _c("v-icon", { attrs: { name: "buttons/table", size: 12 } }),
                _vm._v("\n          Скачать Табель\n        ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.visibleAdmins()
              ? _c(
                  "b-button",
                  {
                    staticClass: "custom-btn-secondary mr-1",
                    attrs: { size: "sm", disabled: _vm.isBusyExport },
                    on: {
                      click: function($event) {
                        return _vm.showImportModal()
                      }
                    }
                  },
                  [
                    _vm.isBusyExport
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", {
                      attrs: { name: "buttons/export", size: 12 }
                    }),
                    _vm._v("\n          Импорт\n        ")
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("export-sidebar", {
              attrs: {
                "sidebar-id": "sidebar-tasks-export",
                "storage-key": "sidebar_tasks_export",
                columns: _vm.exportableFields,
                "data-provider": _vm.provideExportData,
                "data-mapper": _vm.mapTaskForExport,
                "file-name": "Tasks.xlsx",
                "sheet-name": "Tasks",
                "is-busy": _vm.isBusy,
                "items-count": _vm.totalRows
              },
              scopedSlots: _vm._u([
                {
                  key: "extra-buttons",
                  fn: function() {
                    return [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-small text-dark",
                          staticStyle: { "text-decoration": "none !important" },
                          attrs: { variant: "link" },
                          on: {
                            click: function($event) {
                              return _vm.toggleTW()
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "buttons/profile", size: 13 }
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.isIncludeTW ? "Скрыть детали" : "Детали"
                              ) +
                              "\n            "
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n          Колонки\n        ")]
            ),
            _vm._v(" "),
            _vm.canEditTasks()
              ? _c(
                  "b-button",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.showCreateModal()
                      }
                    }
                  },
                  [
                    _vm.isBusy
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n          Новая группа заявок\n        ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "b-tabs",
            {
              staticClass: "custom-tabs",
              model: {
                value: _vm.activeTabIndex,
                callback: function($$v) {
                  _vm.activeTabIndex = $$v
                },
                expression: "activeTabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  attrs: { active: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c("v-icon", {
                            staticClass: "mr-2",
                            attrs: { name: "buttons/table", size: 13 }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Таблица")])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-filters my-2" },
                    [
                      _c(
                        "filters-drawer",
                        {
                          attrs: {
                            query: _vm.filters.query,
                            "is-busy": _vm.isBusy,
                            "filter-tags": _vm.activeFilterTags
                          },
                          on: {
                            "update:query": function($event) {
                              return _vm.$set(_vm.filters, "query", $event)
                            },
                            "remove-tag": _vm.removeFilterTag,
                            submit: _vm.onSearch,
                            clear: _vm.onClearFilters
                          }
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "small text-muted" }, [
                                _vm._v("Период")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "align-items-center" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-start-date",
                                          size: "sm",
                                          type: "date"
                                        },
                                        model: {
                                          value: _vm.filters.start_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "start_date",
                                              $$v
                                            )
                                          },
                                          expression: "filters.start_date"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "px-2",
                                      attrs: { cols: "auto" }
                                    },
                                    [_c("span", [_vm._v("—")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-end-date",
                                          size: "sm",
                                          type: "date"
                                        },
                                        model: {
                                          value: _vm.filters.end_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "end_date",
                                              $$v
                                            )
                                          },
                                          expression: "filters.end_date"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-1", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "small text-muted" }, [
                                _vm._v("Объекты")
                              ]),
                              _vm._v(" "),
                              _c("location-multi-select", {
                                ref: "location_multi_select",
                                attrs: {
                                  id: "location-multi-select",
                                  "start-date": _vm.filters.start_date,
                                  "end-date": _vm.filters.end_date,
                                  "show-date-button": true
                                },
                                on: { onSelect: _vm.onSelectLocation }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.visibleAdmins()
                            ? _c(
                                "b-col",
                                { staticClass: "mt-1", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "small text-muted" },
                                    [_vm._v("Сотрудники")]
                                  ),
                                  _vm._v(" "),
                                  _c("user-multi-select", {
                                    ref: "user_multi_select",
                                    attrs: { id: "user-multi-select" },
                                    on: { onSelect: _vm.onSelectUser }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-1", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "small text-muted" }, [
                                _vm._v("Вид работ")
                              ]),
                              _vm._v(" "),
                              _c("work-type-multi-select", {
                                ref: "work_type_multi_select",
                                attrs: { id: "work-type-multi-select" },
                                on: { onSelect: _vm.onSelectWorkType },
                                model: {
                                  value: _vm.filters.work_type_ids,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "work_type_ids", $$v)
                                  },
                                  expression: "filters.work_type_ids"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-1", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "small text-muted" }, [
                                _vm._v("Группа")
                              ]),
                              _vm._v(" "),
                              _c("b-form-select", {
                                attrs: {
                                  id: "input-task-group",
                                  size: "sm",
                                  options: _vm.taskGroupOptions
                                },
                                model: {
                                  value: _vm.filters.group_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "group_id", $$v)
                                  },
                                  expression: "filters.group_id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mt-1",
                              attrs: { md: "6", cols: "12" }
                            },
                            [
                              _c("label", { staticClass: "small text-muted" }, [
                                _vm._v("Статус заявки")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-select",
                                {
                                  attrs: { id: "input-statuses", size: "sm" },
                                  model: {
                                    value: _vm.filters.status_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "status_id", $$v)
                                    },
                                    expression: "filters.status_id"
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: 0 } }, [
                                    _vm._v("Все статусы")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.activeStatuses, function(option) {
                                    return _c(
                                      "option",
                                      {
                                        key: option.id,
                                        domProps: { value: option.id }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(option.name) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mt-1",
                              attrs: { md: "6", cols: "12" }
                            },
                            [
                              _c("label", { staticClass: "small text-muted" }, [
                                _vm._v("Статус оплаты")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-select",
                                {
                                  attrs: {
                                    id: "input-paid-workers-statuses",
                                    size: "sm"
                                  },
                                  model: {
                                    value: _vm.filters.paid_workers,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "paid_workers", $$v)
                                    },
                                    expression: "filters.paid_workers"
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: 0 } }, [
                                    _vm._v("Все статусы оплаты")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.activePaidWorkersStatuses,
                                    function(option) {
                                      return _c(
                                        "option",
                                        {
                                          key: option.id,
                                          domProps: { value: option.id }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(option.name) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isBusy || (_vm.items && _vm.items.length > 0)
                    ? [
                        _c(
                          "div",
                          { staticClass: "page-table-container" },
                          [
                            _c("b-table", {
                              ref: "tasks",
                              staticClass: "custom-table mb-0 text-small",
                              attrs: {
                                id: "tasks",
                                "select-mode": "multi",
                                "tbody-tr-class": _vm.tbodyRowClass,
                                "sticky-header": "",
                                responsive: "",
                                busy: _vm.isBusy,
                                items: _vm.items,
                                fields: _vm.renderedFields,
                                "no-provider-filtering": "",
                                "no-provider-paging": "",
                                "no-provider-sorting": "",
                                "no-local-sorting": ""
                              },
                              on: {
                                "sort-changed": _vm.sortChanged,
                                "row-clicked": _vm.onRowClicked,
                                "row-dblclicked": _vm.onRowDblClicked
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "table-busy",
                                    fn: function() {
                                      return [
                                        _c("tables-skeleton", {
                                          attrs: {
                                            fields: _vm.renderedFields,
                                            rows: 6
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "head(selected)",
                                    fn: function(row) {
                                      return [
                                        _c("b-form-checkbox", {
                                          staticClass: "mx-1",
                                          attrs: {
                                            indeterminate: _vm.indeterminate,
                                            disabled: _vm.allSelectDisabled,
                                            size: "md"
                                          },
                                          on: { change: _vm.selectAllRows },
                                          model: {
                                            value: _vm.allSelected,
                                            callback: function($$v) {
                                              _vm.allSelected = $$v
                                            },
                                            expression: "allSelected"
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(selected)",
                                    fn: function(row) {
                                      return [
                                        _c("b-form-checkbox", {
                                          staticClass: "mx-1",
                                          attrs: {
                                            size: "md",
                                            checked: row.item.selected
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.onRowClicked(row.item)
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(location_name)",
                                    fn: function(row) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(row.item.location_name) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "m-0 p-0 text-secondary text-small"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(row.item.customer_name)
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(start_date)",
                                    fn: function(row) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatTableDateTime(
                                                row.item.start_date
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(invoice_numb)",
                                    fn: function(row) {
                                      return [
                                        _vm.visibleAdmins() &&
                                        row.item.invoice_numb
                                          ? _c(
                                              "b-button",
                                              {
                                                staticStyle: {
                                                  color: "#1A9167 !important"
                                                },
                                                attrs: {
                                                  variant: "link",
                                                  size: "sm"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showInvoice(
                                                      row.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      row.item.invoice_numb
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    row.item.invoice_numb
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(status_id)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  "custom-tag",
                                                  _vm.getStatusStyle(
                                                    row.item.status_id
                                                  )
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getStatusName(
                                                        row.item.status_id
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              [
                                                _c("font-awesome-icon", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true
                                                      }
                                                    }
                                                  ],
                                                  style: _vm.paidWorkers(row)
                                                    .style,
                                                  attrs: {
                                                    icon: [
                                                      "fas",
                                                      _vm.paidWorkers(row).icon
                                                    ],
                                                    title: "Оплата исполнителям"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("font-awesome-icon", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true
                                                      }
                                                    }
                                                  ],
                                                  style: _vm.readOnly(row)
                                                    .style,
                                                  attrs: {
                                                    icon: [
                                                      "fas",
                                                      _vm.readOnly(row).icon
                                                    ],
                                                    title:
                                                      "Редактирование заявки"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(executor_name)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-truncate",
                                            staticStyle: {
                                              "max-width": "180px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(row.item.executor_name) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "m-0 p-0 text-small" },
                                          [
                                            _vm._v(
                                              _vm._s(row.item.total_manager) +
                                                " ₽"
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(location_rate)",
                                    fn: function(row) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(row.item.payment_first) +
                                            " ₽\n                  "
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "m-0 p-0 text-small" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getUnit(row.item.unit_code)
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(action)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "b-dropdown",
                                          {
                                            staticClass: "custom-dropdown",
                                            attrs: {
                                              variant: "link",
                                              "toggle-class":
                                                "text-decoration-none box-shadow-none",
                                              "no-caret": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "button-content",
                                                  fn: function() {
                                                    return [
                                                      _c("v-icon", {
                                                        attrs: {
                                                          name:
                                                            "buttons/ellipsis_vertical",
                                                          size: 15
                                                        }
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: {
                                                  variant: "success",
                                                  target: "_blank"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.onRead(row.item)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "buttons/eye",
                                                    size: 15
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                      Смотреть\n                    "
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isVisibleReadOnlyForRow(
                                              row.item
                                            )
                                              ? _c(
                                                  "b-dropdown-item",
                                                  {
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onEdit(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        name: "buttons/edit",
                                                        size: 15
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Редактировать\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: { variant: "info" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onCopy(row.item)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "buttons/copy",
                                                    size: 15
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                      Копировать\n                    "
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            row.item.invoice_numb
                                              ? _c(
                                                  "b-dropdown-item",
                                                  {
                                                    attrs: {
                                                      variant: "warning"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onInvoiceFile(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        name: "navbar/invoices",
                                                        size: 15
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Скачать счёт\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isVisibleReadOnlyForRow(
                                              row.item
                                            )
                                              ? _c(
                                                  "b-dropdown-item",
                                                  {
                                                    staticClass: "btn-delete",
                                                    attrs: {
                                                      variant: "danger"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onRemove(row)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        name: "buttons/trash",
                                                        size: 15
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Удалить\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2384955654
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-pagination" },
                          [
                            _c("pagination-footer", {
                              attrs: {
                                "use-router": "",
                                "count-right": "",
                                "current-page": _vm.currentPage,
                                "total-rows": _vm.totalRows,
                                "per-page": _vm.perPage
                              },
                              on: {
                                "update:currentPage": function($event) {
                                  _vm.currentPage = $event
                                },
                                "update:current-page": function($event) {
                                  _vm.currentPage = $event
                                },
                                "update:perPage": function($event) {
                                  _vm.perPage = $event
                                },
                                "update:per-page": function($event) {
                                  _vm.perPage = $event
                                },
                                "page-click": _vm.onPagination,
                                "per-page-change": _vm.onPerPageChange
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "footer-update",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-wrap align-items-center",
                                            staticStyle: { gap: "12px" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-small" },
                                              [
                                                _vm._v(
                                                  "\n                  С заказчика: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalSelectedPrice
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "\n                  | Кол-во исп: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalSelectedWorkers
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "\n                  | Кол-во: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalSelectedUnits
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "\n                  | Исполнителям: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalSelectedWorkerPrice
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "\n                  | Менеджеру: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalSelectedManager
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "\n                  | Руководителю: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalSelectedProject
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.selected.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-wrap align-items-center",
                                                    staticStyle: { gap: "8px" }
                                                  },
                                                  [
                                                    _vm.visibleAdmins()
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "custom-btn-tag text-small",
                                                            style: {
                                                              "--btn-color":
                                                                "#F0F5FF",
                                                              "--btn-border":
                                                                "#D9E0FF",
                                                              "--btn-text":
                                                                "#061178"
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                !_vm.allStatusesEqual ||
                                                                _vm.newStatusDisabled
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onNewStatus()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                name:
                                                                  "buttons/undo",
                                                                size: 10
                                                              }
                                                            }),
                                                            _vm._v(
                                                              "\n                        На доработку\n                      "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "custom-btn-tag text-small",
                                                        style: {
                                                          "--btn-color":
                                                            "#85A5FF",
                                                          "--btn-border":
                                                            "#6C8EEA",
                                                          "--btn-text":
                                                            "#1740B4"
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            !_vm.allStatusesEqual ||
                                                            _vm.payStatusDisabled
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onPayStatus()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            name:
                                                              "buttons/receipt",
                                                            size: 10
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                        На оплату\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.visibleAdmins()
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "custom-btn-tag text-small",
                                                            style: {
                                                              "--btn-color":
                                                                "#FFF7E6",
                                                              "--btn-border":
                                                                "#FFE58F",
                                                              "--btn-text":
                                                                "#FAAD14"
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.payWorkersDisabled
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPayWorkers()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                name:
                                                                  "buttons/payment",
                                                                size: 10
                                                              }
                                                            }),
                                                            _vm._v(
                                                              "\n                        Оплатить исполнителям\n                      "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.visibleAdmins()
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "custom-btn-tag text-small",
                                                            style: {
                                                              "--btn-color":
                                                                "#85A5FF",
                                                              "--btn-border":
                                                                "#6C8EEA",
                                                              "--btn-text":
                                                                "#262626"
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                !_vm.allStatusesEqual ||
                                                                _vm.invoiceDisabled
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onInvoice()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                name:
                                                                  "navbar/stamp",
                                                                size: 10
                                                              }
                                                            }),
                                                            _vm._v(
                                                              "\n                        Выставить счёт\n                      "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "count-right",
                                    fn: function() {
                                      return [
                                        _vm.selected.length > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "text-small mr-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Выбрано: "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.selected.length)
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.selected.length > 0
                                          ? _c("span", {
                                              staticClass: "vertical-divider"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-small text-muted"
                                          },
                                          [
                                            _vm._v("Записей: "),
                                            _c("b", [
                                              _vm._v(_vm._s(_vm.totalRows))
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "vertical-divider"
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1331009284
                              )
                            })
                          ],
                          1
                        )
                      ]
                    : _c(
                        "div",
                        { staticClass: "empty-state-container" },
                        [
                          _c("v-icon", {
                            attrs: { name: "navbar/empty_table", size: 90 }
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.isFiltered
                                  ? "Нет данных соответствующих фильтрам."
                                  : "Нет созданных заявок."
                              )
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isFiltered
                            ? _c(
                                "div",
                                [
                                  _c("p", [
                                    _vm._v("Создайте новую заявку прямо сейчас")
                                  ]),
                                  _vm._v(" "),
                                  _vm.canEditTasks()
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticClass:
                                            "custom-btn-primary mt-1",
                                          attrs: { disabled: _vm.isBusy },
                                          on: {
                                            click: function($event) {
                                              return _vm.onCreate()
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              name: "buttons/plus",
                                              size: 12
                                            }
                                          }),
                                          _vm._v(
                                            "\n                Новая группа заявок\n              "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c("v-icon", {
                            staticClass: "mr-2",
                            attrs: { name: "buttons/calendar", size: 13 }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Календарь")])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c("div", { staticClass: "page-body overflow-auto" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentMonth,
                              expression: "currentMonth"
                            }
                          ],
                          staticClass: "custom-select-filters mr-2",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentMonth = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onCalendarPeriodChange
                            ]
                          }
                        },
                        _vm._l(_vm.monthNames, function(m, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: index } },
                            [_vm._v(_vm._s(m))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentYear,
                              expression: "currentYear"
                            }
                          ],
                          staticClass: "custom-select-filters",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentYear = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onCalendarPeriodChange
                            ]
                          }
                        },
                        _vm._l(_vm.availableYears, function(year) {
                          return _c(
                            "option",
                            { key: year, domProps: { value: year } },
                            [_vm._v(_vm._s(year))]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "calendar-grid header" },
                        _vm._l(_vm.weekDays, function(day) {
                          return _c(
                            "div",
                            { key: day, staticClass: "weekday-cell" },
                            [_vm._v(_vm._s(day))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "calendar-grid body" },
                        _vm._l(_vm.calendarDays, function(day) {
                          return _c(
                            "div",
                            {
                              key: day.dateString,
                              staticClass: "date-cell",
                              class: {
                                "is-not-current-month": !day.isCurrentMonth
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center w-100"
                                },
                                [
                                  _c("span", { staticClass: "day-number" }, [
                                    _vm._v(_vm._s(day.dayNumber))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "tasks-tags-wrapper w-100 mt-1"
                                },
                                _vm._l(day.visibleTasks, function(task) {
                                  return _c(
                                    "div",
                                    {
                                      key: task.id,
                                      staticClass:
                                        "calendar-task-tag text-truncate",
                                      attrs: { title: task.location_name },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handleCalendarTaskClick(
                                            task
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      #" +
                                          _vm._s(task.id) +
                                          " " +
                                          _vm._s(task.location_name) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              day.visibleTasks && day.visibleTasks.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "mt-auto pt-1 w-100" },
                                    [
                                      day.hiddenTasksCount > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "calendar-task-tag more-tag text-center",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showTasksInTable(
                                                    day.dateString
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Ещё +" +
                                                  _vm._s(day.hiddenTasksCount) +
                                                  " ...\n                    "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "calendar-task-tag more-tag text-center",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showTasksInTable(
                                                    day.dateString
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Перейти\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("tasks-import", {
        ref: "tasks_import",
        on: { refresh: _vm.handleTasksImport }
      }),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "tasks_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("task-group-create", {
        ref: "task_group_create_modal",
        on: { refresh: _vm.getItems }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalSelectPayOrganization",
          attrs: {
            id: "modal-select-pay-organization",
            title: "Организация",
            "ok-title": "Оплатить",
            "button-size": "sm",
            "ok-disabled": this.currentPayOrganization == null,
            "cancel-title": _vm.$t("message.actions.cancel")
          },
          on: {
            ok: function($event) {
              return _vm.onPay()
            }
          }
        },
        [
          _c("organization-select", {
            ref: "organization_select",
            attrs: { id: "input-org-select", value: 0 },
            on: { onSelect: _vm.onSelectOrg }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b61eda6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b61eda6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/Tasks.vue
// module id = null
// module chunks = 